import { getColor } from './colors';
import { getRem } from './spacing';

export function getCanvasColor(colorToken: string): string {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(colorToken.replace('var(', '').replace(')', ''))
    .trim();
}

export function getCanvasFontSize(size: number): string {
  const value = getRem(size);

  const el = document.createElement('span');
  el.style.fontSize = value;
  el.style.position = 'absolute';
  el.style.visibility = 'hidden';

  document.body.appendChild(el);
  const computed = getComputedStyle(el).fontSize;
  document.body.removeChild(el);

  return computed;
}

export function getCanvasFont(
  weight: string,
  size: number,
  family = 'sans-serif',
): string {
  return `${weight} ${getCanvasFontSize(size)} ${family}`;
}

export function getCanvasColorByName(colorName: string): string {
  return getCanvasColor(getColor(colorName));
}
